<template>
  <div class="activity">
    <div class="hall-head_box">
      <div class="hall-head">
        {{ $t('优惠活动') }}
        <div class="xzimg"></div>
        <div class="xxbox" @click="$parent.openKefu()"><!----></div>
      </div>

      <div data-v-730dfc06="" class="navcontent">
        <div data-v-730dfc06="" class="navbars">
          <div data-v-730dfc06="" @click="type=0" :class="{active:type==0}" class="navbar"> {{ $t('全部优惠') }} </div>
          <div data-v-730dfc06="" @click="type=1" :class="{active:type==1}" class="navbar"> {{ $t('限时活动') }} </div>
          <div data-v-730dfc06="" @click="type=2" :class="{active:type==2}" class="navbar"> {{ $t('新人首存') }} </div>
          <div data-v-730dfc06="" @click="type=3" :class="{active:type==3}" class="navbar"> {{ $t('日常活动') }} </div>
        </div>
      </div>

    </div>

    <!----><!---->
    <div class="activecont">
      <div class="activeinner">
        <div class="PulldownRefresh">
          <div class="van-pull-refresh">
            <div class="van-pull-refresh__track" style="transition-duration: 0ms">
              <div class="van-pull-refresh__head" style="height: 80px"></div>
              <div class="main_content" v-if="type==0">
                <div class="activebox" v-for="(item, index) in activitylistList" :key="index" @click="$parent.goNav(`/activityInfo?id=${item.id}`)">
                  <img :src="imgBase + item.banner" />
                </div>
              </div>
              <div v-else data-v-9349a398="" class="main_content">
                <div data-v-730dfc06="" class="expectation"><img data-v-730dfc06="" src="/static/img/expectation.ccc42cce.png"
                                                                 alt=""></div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <!---->
  </div>
</template>
<script>
import {translateText} from "../../common/utils";

export default {
  name: 'activity',
  data() {
    return {
      activitytypeList: [],
      actType: '',
      activitylistList: [],
      // imgBase: 'https://youxi3.web3bc.com/uploads/',
      imgBase: 'https://api.n778.com/uploads/',
      type:0
    };
  },
  created() {
    let that = this;
    that.activitytype();
    that.activitylist();
  },
  methods: {
    async showTost(type = 0, title) {
      const message = await translateText([title]);
      this.$parent.showTost(type, message[0]);
    },
    activitytype() {
      let that = this;
      that.$apiFun.post('/api/activitytype', {}).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.activitytypeList = res.data;
        }
      });
    },
    activitylist() {
      let that = this;
      let info = that.actType == '' ? {} : { type: that.actType };
      that.$parent.showLoading();
      that.$apiFun.post('/api/activitylist', info).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.activitylistList = res.data.data;
        }
        that.$parent.hideLoading();
      });
    },
    changActType(val) {
      let that = this;
      if (val == that.actType) {
        return;
      }
      that.actType = val;
      that.activitylist();
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.activity {
  //position: absolute;
  //top: 0;
  //left: 0;
  width: 100%;
  margin: auto;
  background-color: #000;
  padding-bottom: 1.79rem;  // 底部导航栏高度
  height: 100%;
  color: #fff;
  font-family: PingFang SC;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.activity div::-webkit-scrollbar {
  width: 0;
  height: 0;
  display: none;
}
.activity .colosline {
  width: 100%;
  height: 0.08rem;
  background: -webkit-linear-gradient(left, #f08448, #ffce70, #f08449);
  background: linear-gradient(90deg, #f08448, #ffce70, #f08449);
}
.activity .backhead {
  width: 100%;
  height: 1.17333rem;
  border-bottom: 0.02667rem solid #f6f6f6;
  font-size: 0.45333rem;
  color: #424653;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  position: relative;
  background: #fff;
}
.activity .backhead img {
  width: 0.64rem;
  height: 0.64rem;
  position: absolute;
  left: 0.26667rem;
  top: 0.26667rem;
}
.activity .hall-head {
  box-sizing: border-box;
  height: 1.17rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.48rem;
  font-weight: bold;
  position: relative;
}
.hall-head_box{
}
.activity .hall-head .xzimg {
  background-image: url("/static/image/new/download-icon.png");
  background-size: 100% 100%;
  right: 1.23rem;
}
.activity .hall-head .kefuicon,
.activity .hall-head .xzimg {
  width: 0.56rem;
  height: 0.56rem;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.activity .hall-head .kefuicon {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAilBMVEUAAABdYm1eYm1eYm1eYm1paXBeYm1bZm5eYm1dYW1dYm5dYm5dY3BeYm1dYm1eYm1eYm3xjlZeYm3xjlbxj1byjlZeYmxeYW1dY21eYmxeYm3rj1FeYm1eYm1eYm1eYm5gYG9eYW5hYWnxjlZeYm3xjlXwjlZfYm3yjlfyjFXxjlVdYm5eYm3xjlZfMdjrAAAALHRSTlMA8Pv1ygbqEp14HxsNxaukXNvTz6yXb2NRTEYM5JOAODMlCfezs56MTzwSawcR0WQAAAFYSURBVDjLxZNZtoMgEEQRRY1TYtQ4a+bp4f639+g4HUSif6mPHC1ubLqgES+Slq6Ose6WKUFyOZVOB+mVI+OygnIqsnluQwVt5JxqJhYhVrJVZWRCQVu7f7e9j5FMOQPawH9CCd2YgA9w45nNPCbBqFAXTXSFTfMh7aCwPQVPmNk7ztoyx0OCPKHOfvirUGjPOQpzLBG0YJNDMCajQEQESbuimAZ71mgnNKN+TSPoQBdB0AFp60ANqZ82voHIhpY65BvYZvJDcHUzfDz+7Zm3RP68+Vw8Y+AF86OmaYIwisKAPURc4MMR4hS+A0CnIOeOsLsUundEoHfYc+GbvZ7HSyHodfcvF//+aq84jJfIzF9cdw0Io1Cu4GwYrmwFaHIjI1cGHafLXA1HbEqXjxpm6Wu1U2Fo+SzjjG4kVRV+r1IOxXSUEoOzCO43DhhLpZUTZ0ubceup/w/07lIHQOGMRwAAAABJRU5ErkJggg==)
    no-repeat;
  background-size: 100% 100%;
  right: 1.34667rem;
}
.activity .hall-head .xxbox {
  width: 0.56rem;
  height: 0.56rem;
  background-image: url("/static/image/new/msg-icon.png?v=1");
  background-size: 100% 100%;
  position: absolute;
  right: 0.4rem;
  top: 50%;
  transform: translateY(-50%);
}
.activity .hall-head .xxbox font {
  width: 0.16rem;
  height: 0.16rem;
  border-radius: 50%;
  background: #f18e56;
  position: absolute;
  top: -0.08rem;
  right: -0.08rem;
}
.activity .navcontent {
  float: left;
  width: 100%;
  height: 1.06667rem;
  overflow-y: hidden;
  overflow-x: scroll;
  margin-bottom: 0.26667rem;
}
.activity .navcontent .navbars {
  width: auto;
  margin: 0.1rem 0 .3rem;
  display: flex;
  white-space: nowrap;
  padding: 0 .4rem;
}
.activity .navcontent .navbars .navbar {
  padding: 0.16rem 0.32rem;
  margin-left: 0.51rem;
  color: #E8E8F6;
  font-size: 0.32rem;
  font-weight: 500;
  text-align: center;
  background: rgba(255, 255, 255, 0.10);
  border: 0.03rem solid rgba(255, 255, 255, 0.10);
  border-radius: .11rem;
  &:first-child {
    margin-left: 0;
  }
}
.activity .navcontent .navbars .active {
  background: linear-gradient( 180deg, #2E0B71 0%, #7214D7 100%);
  box-shadow: inset 0rem 0.11rem 0.21rem 0rem rgba(94,83,142,0.2), inset 0rem -0.11rem 0.21rem 0rem rgba(94,83,142,0.2);
  border-color: #2E0B71;
}
.activity .activecont {
  width: 100%;
  flex: 1;
  overflow-x: hidden;
  overflow-y: scroll;
}
.activity .activecont .activeinner {
  width: 100%;
  padding: 0.4rem 0.4rem 0.26667rem 0.4rem;
  padding-top: 0 !important;
}
.activity .activecont .activeinner .activebox {
  overflow: hidden;
  width: 9.2rem;
  height: 3.86667rem;
  margin-top: 0.26667rem;
  position: relative;
  border-radius: 0.26667rem;
}
.activity .activecont .activeinner .activebox img {
  width: 9.2rem;
  height: 4rem;
}
.activity .activecont .activeinner .activebox:first-child {
  margin-top: -0.13333rem;
}
.activity .activecont .activeinner .expectation {
  padding-top: 0.4rem;
}
.activity .activecont .activeinner .expectation img {
  width: 100%;
}
.activity .contentsds {
  width: 100%;
  height: calc(100% - 1.17333rem);
  overflow-x: hidden;
  overflow-y: scroll;
}
.activity .contentsds .contentsdsinner {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/activity.vue